import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SubscriptionPlanGuard, LicensingGuard, MlValidationFeedbacksGuard } from '@shared/guards';
import { ROUTE_NAMES } from './route-names';

const ORG_ID = 'organizationId';
const MACHINE_ID = 'machineId';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_NAMES.FAULT_ANALYSIS,
    pathMatch: 'full',
  },
  {
    path: 'state',
    redirectTo: ROUTE_NAMES.FAULT_ANALYSIS,
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./tab-container/tab-container.component').then((m) => m.TabContainerComponent),

    canActivate: [MsalGuard],
    children: [
      {
        path: ROUTE_NAMES.NO_SELECTED_ROUTE,
        loadComponent: () =>
          import('./tab-container/no-selected-route/no-selected-route.component').then((m) => m.NoSelectedRouteComponent),
        canActivate: [MsalGuard],
      },
      {
        path: ROUTE_NAMES.FAULT_ANALYSIS,
        loadComponent: () =>
          import('./tab-container/fault-analysis/fault-analysis.component').then((m) => m.FaultAnalysisComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
      },
      {
        path: `${ROUTE_NAMES.OVERVIEW}/:${ORG_ID}`,
        loadComponent: () => import('./tab-container/overview/overview.component').then((m) => m.OverviewComponent),
        canActivate: [MsalGuard],
      },
      {
        path: `${ROUTE_NAMES.FAULT_ANALYSIS}/:${ORG_ID}`,
        loadComponent: () =>
          import('./tab-container/fault-analysis/fault-analysis.component').then((m) => m.FaultAnalysisComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
      },
      {
        path: `${ROUTE_NAMES.SYSTEM_HEALTH}/:${ORG_ID}`,
        loadComponent: () => import('./tab-container/system-health/system-health.component').then((m) => m.SystemHealthComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
      },
      {
        path: ROUTE_NAMES.FAULT_RECOMMENDATIONS,
        loadComponent: () =>
          import('./tab-container/fault-recommendations/fault-recommendations.component').then(
            (m) => m.FaultRecommendationsComponent
          ),
        canActivate: [MsalGuard],
      },
      {
        path: `${ROUTE_NAMES.TROUBLESHOOTING}/:${ORG_ID}`,
        loadComponent: () =>
          import('./tab-container/troubleshooting/troubleshooting.component').then((m) => m.TroubleshootingComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
      },
      {
        path: `${ROUTE_NAMES.MACHINE_OVERVIEW}/:${ORG_ID}`,
        loadComponent: () =>
          import('./tab-container/machine-overview/machine-overview.component').then((m) => m.MachineOverviewComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./tab-container/machine-overview/machine-list/machine-list.component').then((m) => m.MachineListComponent),
            canActivate: [MsalGuard],
          },
          {
            path: `machine/:${MACHINE_ID}`,
            loadComponent: () =>
              import('./tab-container/machine-overview/machine-details').then((m) => m.MachineDetailsComponent),
            canActivate: [MsalGuard],
          },
        ],
      },
      {
        path: `${ROUTE_NAMES.SETTINGS}/:${ORG_ID}`,
        loadComponent: () => import('./tab-container/settings/settings.component').then((m) => m.SettingsComponent),
        canActivate: [MsalGuard, SubscriptionPlanGuard],
      },
      {
        path: `${ROUTE_NAMES.REMOTE_ACCESS}/:${ORG_ID}`,
        loadComponent: () => import('./tab-container/remote-access/remote-access.component').then((m) => m.RemoteAccessComponent),
        canActivate: [MsalGuard],
      },
      {
        path: `${ROUTE_NAMES.LICENSING}/:${ORG_ID}`,
        loadComponent: () => import('./tab-container/licensing/licensing.component').then((m) => m.LicensingComponent),
        canActivate: [MsalGuard, LicensingGuard],
      },
      {
        path: ROUTE_NAMES.MODEL_FEEDBACKS,
        loadComponent: () =>
          import('./tab-container/ml-validation-feedbacks/ml-validation-feedbacks.component').then(
            (m) => m.MlValidationFeedbacksComponent
          ),
        canActivate: [MsalGuard, MlValidationFeedbacksGuard],
      },
      // Wildcard route - must be last! Catches all undefined URLs and redirects to fault-analysis
      {
        path: '**',
        redirectTo: ROUTE_NAMES.NO_SELECTED_ROUTE,
      },
    ],
  },
];
